import React from 'react'
import { StyledBackground } from './BackGroundStyles'

type BackgroundProps = {
  clicked: boolean
  onClick: React.MouseEventHandler<HTMLDivElement>
}

export const BackGround = ({ clicked, onClick }: BackgroundProps) => {
  return <StyledBackground isOpen={clicked} onClick={onClick}></StyledBackground>
}

